import { useState } from "react";
import { Phone } from "lucide-react";
import { useLocations } from "@/hooks/useLocations";

const navItems = [
  { label: "For Sale", href: "/properties-for-sale" },
  { label: "For Rent", href: "/properties-for-rent" },
  { label: "Services", href: "/services" },
  { label: "Locations", href: "/locations" },
  { label: "Off-Plan Investments", href: "/off-plan-investments" },
  { label: "About", href: "/about" },
  { label: "Contact", href: "/contact" },
];

const fallbackLocations = ["Westlands", "Riverside", "Brookside", "Kitisuru", "Karen", "Lavington", "Kilimani", "Muthaiga"];

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { data: locations = [] } = useLocations();

  const locationNames = Array.from(
    new Set(locations.map((location) => location.name?.trim()).filter(Boolean))
  ) as string[];

  const marqueeLocations = locationNames.length > 0 ? locationNames : fallbackLocations;

  return (
    <>
      <header className="fixed top-0 left-0 right-0 z-50 border-b border-accent/25 bg-brand-gradient shadow-lg">
        <div className="flex items-stretch justify-between px-6 md:px-16">
          <a href="/" className="flex items-stretch gap-3 self-stretch">
            <img src="/logo2f.png" alt="Wild Gates Real Estate" className="h-[88px] md:h-[104px] w-auto object-contain" />
          </a>

          <nav className="hidden lg:flex items-center gap-8 py-3">
            {navItems.map((item) => {
              return (
                <a
                  key={item.label}
                  href={item.href}
                  className="font-open-sans font-semibold text-xs tracking-widest uppercase text-primary-foreground/80 hover:text-accent transition-colors duration-300"
                >
                  {item.label}
                </a>
              );
            })}
          </nav>

          <div className="flex items-center gap-4 py-3">
            <a
              href="tel:+254111653233"
              className="hidden md:flex items-center gap-2 font-open-sans font-semibold text-xs tracking-wider uppercase text-primary-foreground/80 hover:text-accent transition-colors"
            >
              <Phone className="w-3.5 h-3.5" />
              Call Us
            </a>
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="lg:hidden font-open-sans font-semibold text-sm tracking-widest uppercase text-white"
            >
              {menuOpen ? "Close" : "Menu"}
            </button>
          </div>
        </div>
        <div className="h-px w-full bg-accent/20" />
        <div className="relative overflow-hidden bg-[#FFFFFF] py-2">
          <div className="pointer-events-none absolute inset-y-0 left-0 w-12 bg-gradient-to-r from-[#FFFFFF] to-transparent" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-12 bg-gradient-to-l from-[#FFFFFF] to-transparent" />
          <div className="animate-location-marquee flex w-max items-center whitespace-nowrap">
            {[0, 1].map((copy) => (
              <div key={copy} className="flex items-center">
                {marqueeLocations.map((location, index) => (
                  <span
                    key={`${copy}-${location}-${index}`}
                    className="px-4 font-open-sans text-[11px] md:text-xs font-bold uppercase tracking-[0.28em] text-[#032820]"
                  >
                    {location}
                    <span className="ml-4 text-[#032820]/60">•</span>
                  </span>
                ))}
              </div>
            ))}
          </div>
        </div>
      </header>

      {menuOpen && (
        <div className="fixed inset-0 z-40 bg-brand-gradient flex flex-col items-center justify-center gap-8">
          <button
            onClick={() => setMenuOpen(false)}
            className="absolute top-5 right-6 font-open-sans font-semibold text-sm tracking-widest uppercase text-white"
          >
            Close
          </button>
          {navItems.map((item) => {
              return (
                <a
                  key={item.label}
                  href={item.href}
                  onClick={() => setMenuOpen(false)}
                  className="font-open-sans font-bold text-2xl text-white hover:text-accent transition-colors"
                >
                  {item.label}
                </a>
              );
            })}
        </div>
      )}
    </>
  );
};

export default Header;
